/** The search of `/clients/$organizationId`: the tab and the month the file opens on (`AM-496`). */
export interface ClientSearch {
  tab?: 'tickets' | 'hours' | 'contracts' | 'invoices';
  month?: string;
}

const TABS = ['tickets', 'hours', 'contracts', 'invoices'] as const;

/**
 * `?tab=hours&month=2026-10` opens the file of a customer on its hours of that month, as the number
 * of hours of a month in the list of customers does (rule 16 of the billing model). Anything else is
 * dropped, never thrown on.
 */
export function clientSearchSchema(search: Record<string, unknown>): ClientSearch {
  const tab = search['tab'];
  const month = search['month'];
  return {
    ...(typeof tab === 'string' && (TABS as readonly string[]).includes(tab)
      ? { tab: tab as NonNullable<ClientSearch['tab']> }
      : {}),
    ...(typeof month === 'string' && /^\d{4}-(0[1-9]|1[0-2])$/.test(month) ? { month } : {}),
  };
}
